import * as React from "react"
const RankingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="#fff">
      <rect width={7} height={11} x={3} y={19} data-original="#000000" rx={2} />
      <rect
        width={8}
        height={15}
        x={12}
        y={15}
        data-original="#000000"
        rx={2}
      />
      <rect
        width={7}
        height={10}
        x={22}
        y={20}
        data-original="#000000"
        rx={2}
      />
      <path
        d="M22.928 11a1 1 0 0 1 1.366-.366l.866.5a1 1 0 1 1-1 1.732l-.866-.5A1 1 0 0 1 22.928 11zm0-8a1 1 0 0 0 1.366.366l.866-.5a1 1 0 1 0-1-1.732l-.866.5A1 1 0 0 0 22.928 3zM24 7a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2h-1a1 1 0 0 0-1 1zM9.072 11a1 1 0 0 0-1.366-.366l-.866.5a1 1 0 1 0 1 1.732l.866-.5A1 1 0 0 0 9.072 11zm0-8a1 1 0 0 1-1.366.366l-.866-.5a1 1 0 1 1 1-1.732l.866.5A1 1 0 0 1 9.072 3zM6 8h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2zm15.404-1.78-1.925 1.877.455 2.65a1.07 1.07 0 0 1-1.553 1.128l-2.38-1.251-2.38 1.251a1.07 1.07 0 0 1-1.553-1.128l.455-2.65-1.925-1.877a1.07 1.07 0 0 1 .593-1.826l2.661-.387 1.19-2.411a1.07 1.07 0 0 1 1.919 0l1.19 2.411 2.661.387a1.07 1.07 0 0 1 .593 1.826z"
        data-original="#000000"
      />
    </g>
  </svg>
)
export default RankingIcon
